// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: XtzpQ4knX8NF
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Password1 from "../../Password1"; // plasmic-import: _8NThLJuHFRw/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 3fSxDxNzNmO_/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCreateNewPassword.module.css"; // plasmic-import: XtzpQ4knX8NF/css
import _64E43643E6Dfc41C4712B72BCopyOfUntitledDesignP5002PngUtCVt1HrbpSs from "./images/_64E43643E6Dfc41C4712B72BCopyOfUntitledDesignP5002Png.png"; // plasmic-import: UtCVt1hrbpSS/picture

createPlasmicElementProxy;

export const PlasmicCreateNewPassword__VariantProps = new Array();

export const PlasmicCreateNewPassword__ArgProps = new Array();

const $$ = {};

function PlasmicCreateNewPassword__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"90px"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={
              hasVariant(globalVariants, "screen", "mobile") ? "150px" : "179px"
            }
            loading={"lazy"}
            src={{
              src: _64E43643E6Dfc41C4712B72BCopyOfUntitledDesignP5002PngUtCVt1HrbpSs,
              fullWidth: 500,
              fullHeight: 500,
              aspectRatio: undefined
            }}
          />

          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__nou3N
            )}
          >
            {"Create New Password"}
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__keBZa)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__t5KBi
              )}
            >
              {"New Password"}
            </div>
            <Password1
              data-plasmic-name={"password"}
              data-plasmic-override={overrides.password}
              className={classNames("__wab_instance", sty.password)}
            />
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__wdAH)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__xg5He
              )}
            >
              {"Confirm New Password"}
            </div>
            <Password1
              data-plasmic-name={"confirmPassword"}
              data-plasmic-override={overrides.confirmPassword}
              className={classNames("__wab_instance", sty.confirmPassword)}
            />

            <CustomErrorComponent
              data-plasmic-name={"customErrorInstance"}
              data-plasmic-override={overrides.customErrorInstance}
              className={classNames("__wab_instance", sty.customErrorInstance)}
              customErrorText={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nddhJ
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small") ? (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <span
                        className={"plasmic_default__all plasmic_default__span"}
                        style={{ color: "#FF0000" }}
                      >
                        {"Failed to login"}
                      </span>
                    </React.Fragment>
                  )}
                </div>
              }
            />
          </div>
          <div
            data-plasmic-name={"submitButton"}
            data-plasmic-override={overrides.submitButton}
            className={classNames(projectcss.all, sty.submitButton)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___2AMu
              )}
            >
              {"Submit"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "img",
    "password",
    "confirmPassword",
    "customErrorInstance",
    "submitButton"
  ],

  img: ["img"],
  password: ["password"],
  confirmPassword: ["confirmPassword"],
  customErrorInstance: ["customErrorInstance"],
  submitButton: ["submitButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreateNewPassword__ArgProps,
          internalVariantPropNames: PlasmicCreateNewPassword__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreateNewPassword__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCreateNewPassword";
  } else {
    func.displayName = `PlasmicCreateNewPassword.${nodeName}`;
  }
  return func;
}

export const PlasmicCreateNewPassword = Object.assign(
  // Top-level PlasmicCreateNewPassword renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    img: makeNodeComponent("img"),
    password: makeNodeComponent("password"),
    confirmPassword: makeNodeComponent("confirmPassword"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    submitButton: makeNodeComponent("submitButton"),
    // Metadata about props expected for PlasmicCreateNewPassword
    internalVariantProps: PlasmicCreateNewPassword__VariantProps,
    internalArgProps: PlasmicCreateNewPassword__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicCreateNewPassword;
/* prettier-ignore-end */
